import EventoVehiculo from '../../01.-Domain/Entities/EventoVehiculo';
import TipoVehiculo from '../../01.-Domain/Entities/TipoVehiculo';
import VehiculoRepository from '../../03.-Infraestructure/Repositories/VehiculoRepository';
import IVehiculoService from '../ServicesInterfaces/IVehiculoService';

class VehiculoService implements IVehiculoService {
  async InsertarEvento(matricula: string, evento: EventoVehiculo): Promise<Boolean> {
    return await VehiculoRepository.InsertarEvento(matricula, evento);
  }

  async ActualizarVehiculos(vehiculos: TipoVehiculo[]) {
    return await VehiculoRepository.ActualizarVehiculos(vehiculos);
  }
}

export default new VehiculoService();
